import Validator from '../validator/validator.js';
import Validation from '../validation/validation.js';
import Validators from '../validators/validators.js';
import Errors from '../validation_errors/validation_message_not_found_error.js';

export default angular.module('BaseClass.validatable.field',[Validator, Validation, Validators, Errors])
    .factory('BCVField', function(BCValidator, BCValidation, BCvalidators, BCValidationMessageNotFoundError) {
        function Field(name, validationSet) {
            var field = [];

            field.addValidators = function(validationSet) {
                _.each(validationSet, field.addValidator);
            };

            field.addValidator = function(options, validationName) {
                var validator = BCvalidators.find(validationName) || new BCValidator(options, validationName),
                    configuredFns = _.flatten([validator.configure(options)]);

                if (_.isUndefined(validator.message))
                    throw new BCValidationMessageNotFoundError(validationName, name);

                _.each(configuredFns, function(configuredFn) {
                    field.push(new BCValidation(name, configuredFn));
                });
            };

            field.addValidators(validationSet);
            return field;
        }

        return Field;
    }).name;
